import * as React from 'react';
import { useRef, useState } from 'react';

import { Scrollbar, ScrollbarWrapper, ScrolleableWrapper } from './horizontal-scroller.styled';

interface IScrollerProps {
  children: React.ReactNode;
  theme?: ScrollbarTheme;
  hidden?: boolean;
}

export enum ScrollbarTheme {
  DARK = 'dark',
  LIGHT = 'light',
}

export const HorizontalScroller = ({
  children,
  hidden = false,
  theme = ScrollbarTheme.DARK,
}: IScrollerProps) => {
  const [scrollLeft, setScrollLeft] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setScrollLeft(event.currentTarget.scrollLeft);
  };

  const scrollWidth = ref?.current?.scrollWidth || 0;
  const scrollerWidthPercent = ((ref?.current?.offsetWidth || 0) / scrollWidth) * 100;

  const showScrollbar = !hidden && scrollerWidthPercent < 100;

  return (
    <>
      <ScrolleableWrapper ref={ref} onScroll={handleScroll}>
        {children}
      </ScrolleableWrapper>
      {showScrollbar && (
        <ScrollbarWrapper data-testid="scrollbar-wrapper" $theme={theme}>
          <Scrollbar
            widthPercent={scrollerWidthPercent}
            scrollLeft={scrollLeft}
            scrollWidth={scrollWidth}
          />
        </ScrollbarWrapper>
      )}
    </>
  );
};

export default HorizontalScroller;
